import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 125px;
  height: 100%;
  background: ${(p) => p.theme.red};
  cursor: pointer;
`;

export const Label = styled.div`
  color: white;
`;
